import React, { useContext } from 'react'
import { Box, Text, Flex } from 'rebass/styled-components'
import { Link } from 'gatsby'
import styled, { ThemeContext } from 'styled-components'
import Spacer from '../components/general/Spacer'

const BackLink = styled(Link)`
    color: ${(props) => props.theme.colors.black};
    font-weight: ${(props) => props.theme.fontWeights.semibold};
    display: inline-block;
    text-decoration: none;
    overflow: hidden;
    padding: 0 0 3px 0;
    position: relative;
    border-radius: 4px;
    &:hover {
        text-decoration: none;
    }
    &::before,
    &::after {
        background-color: ${(props) => props.theme.colors.black};
        content: '';
        display: inline-block;
        height: 2px;
        left: 0;
        opacity: 1;
        position: absolute;
        bottom: 0;
        width: 100%;
        z-index: 0;
    }
    &::before {
        background-color: ${(props) => props.theme.colors.aquaDark};
        z-index: 1;
        transform: translateX(100%);
        transition-duration: 350ms;
        transition-timing-function: cubic-bezier(0.77, 0.0, 0.175, 1);
        transition-property: transform;
    }

    :hover::before {
        transform: translateX(0);
    }  
`

const Breadcrumbs = ({ firstModule, options, data }) => {
    const theme = useContext(ThemeContext)
    let urlParentLabel = ''
    let url = '#'

    /* TO DO: Redo this to make it more dynamic */
    if (data) {
        if (data.categories && data.categories.length) {
            if (
                data.categories.includes('recently-sold') ||
                data.categories.includes('sold')
            ) {
                urlParentLabel = 'Previously Handled'
                url = '/cars-for-sale/sold/'
            } else if (
                data.categories.includes('new-entry') ||
                data.categories.includes('under-offer') ||
                data.categories.includes('sale-agreed') ||
                data.categories.includes('available')
            ) {
                urlParentLabel = 'Offered for sale'
                url = '/cars-for-sale/available/'
            }
        }

        if (data.categories && data.categories.includes('team')) {
            urlParentLabel = 'The Company'
            url = '/about/'
        } else if (data.categories && data.categories.includes('galleries')) {
            urlParentLabel = 'Galleries'
            url = '/galleries/'
        }
    }

    return (
        <>
            { data && (
                <Box
                    bg={options.bg}
                    pl={['sm', 'sm', 'sm', 'sm', 'md']}
                    pr={['sm', 'sm', 'sm', 'sm', 'md']}
                    pt={[firstModule ? 'xxl' : 'lg', firstModule ? 'xxl' : 'lg', firstModule ? 'xxl' : 'lg', firstModule ? 'xxl' : 'lg', firstModule ? 'xxxl' : 'lg']}
                >
                    <Spacer spacing={options.spacing}>
                        <Box variant="container" pt={ firstModule ? 'lg' : ''}>
                            <Flex>
                                <Link
                                    to={url}
                                    theme={theme}
                                    css={{
                                        color: 'black',
                                        textDecoration: 'none',
                                        '@media screen and (max-width: 540px)': {
                                            display: 'none',
                                        },
                                    }}
                                >{urlParentLabel}</Link>
                                <Box
                                    px='xxs'
                                    css={{
                                        '@media screen and (max-width: 540px)': {
                                            display: 'none',
                                        },
                                    }}>{'>'}</Box>
                                <Box><Text as="span" itemProp="name">{data.title}</Text></Box>
                            </Flex>
                            <Flex pt='xxs'>
                                <Box pr='xxs'>{'<'}</Box>
                                {/* <BackLink to="" onClick={(e) => goBack(e)} theme={theme}>Back</BackLink> */}
                                <BackLink to={url} theme={theme}>Back</BackLink>
                            </Flex>
                        </Box>
                    </Spacer>
                </Box>
            )}
        </>
    )
}

export default Breadcrumbs
